<template>
  <span v-if="isMarked" :class="`icon-lock icon-lock-${color}`" role="img" :aria-label="label">
    <span class="dot"></span>
    <span class="locked"></span>
  </span>
</template>

<script setup lang="ts">
  import { privacyTypes, privacyTypeColors, privacyTypeSlugs } from '~/constants';

  const props = defineProps<{
    publishedTo?: number | string;
  }>();

  // Normalise: publishedTo arrives as a number or a numeric string ('2') across call sites.
  const type = computed(() => Number(props.publishedTo));

  // Only internal/service carry a lock; external (and unset) render nothing.
  const isMarked = computed(() => type.value === privacyTypes.INTERNAL || type.value === privacyTypes.SERVICE);

  const color = computed(() => privacyTypeColors[type.value]);

  // Text alternative so the meaning isn't conveyed by colour alone (WCAG 1.4.1).
  const label = computed(() => {
    const slug = privacyTypeSlugs[type.value] ?? '';
    return slug ? slug.charAt(0).toUpperCase() + slug.slice(1) : '';
  });
</script>
